export const images = {
	corporate: {
		hero: {
			alt: 'Hero Image',
			src: '/images/corporate/hero-banner.png',
		},
		jobs: {
			alt: 'Logo',
			src: '/images/corporate/plus-up-logo-horizontal.png',
		},
		plusUp: {
			alt: 'Logo',
			src: '/images/corporate/plus-up-logo-horizontal.png',
		},
		projectCorporate: {
			alt: 'Logo',
			src: '/images/corporate/project-recruitment.png',
		},
		projectsPersonal: {
			alt: 'Logo',
			src: '/images/corporate/project-personal.png',
		},
	},
	hero: {
		registerComplete: {
			alt: 'Registration Complete',
			src: '/images/hero/register-complete.png',
		},
	},
	logo: {
		facebook: {
			alt: 'Facebook',
			src: '/images/logos/facebook-round.png',
		},
		instagram: {
			alt: 'Instagram',
			src: '/images/logos/instagram-round.png',
		},
		line: {
			alt: 'Line',
			src: '/images/logos/line-round.png',
		},
		plusUpRecruit: {
			alt: 'Logo',
			src: '/images/logos/plus-up-recruit-logo-horizontal.png',
		},
	},
	mocked: {
		featured: {
			alt: 'Featured',
			src: '/images/mocked/special-feature.jpg',
		},
		hiring: {
			alt: 'Hiring',
			src: '/images/mocked/we-are-hiring.png',
		},
	},
};
